




































































































































































































































































































































































import Vue from 'vue';
import moment from 'moment-timezone';
import _ from 'lodash';

import { Paciente } from '../../../../back/src/entity/Paciente';
import { PlanoDeSaude } from '../../../../back/src/entity/PlanoDeSaude';
import {
  Acompanhamento,
  EscolaridadePaciente,
  EstadoCivilPaciente,
  EstadosBrasil,
  SimNaoNaoSei,
  TipoTelefone,
} from '../../../../back/src/types';

import {
  escolaridadeStrings,
  estadoCivilStrings,
  estadosBrasilStrings,
  simNaoNaoSabeStrings,
  tipoTelefoneIcons,
} from '../../utils/constants';

import IfEmptyTextPrintNA from '../IfEmptyTextPrintNA.vue';
import ThePacientesCadastroInternoAcompanhamento from './ThePacientesCadastroInternoAcompanhamento.vue';
import ThePacientesCadastroInternoDadosPessoais from './ThePacientesCadastroInternoDadosPessoais.vue';
import ThePacientesCadastroInternoEndereco from './ThePacientesCadastroInternoEndereco.vue';
import ThePacientesCadastroInternoPlanosDeSaude from './ThePacientesCadastroInternoPlanosDeSaude.vue';

export default Vue.extend({
  name: 'ThePacientesDadosCadastro',
  components: {
    IfEmptyTextPrintNA,
    ThePacientesCadastroInternoAcompanhamento,
    ThePacientesCadastroInternoDadosPessoais,
    ThePacientesCadastroInternoEndereco,
    ThePacientesCadastroInternoPlanosDeSaude,
  },
  props: {
    paciente: {
      type: Object as () => Paciente,
    },
  },
  data() {
    return {
      showAcompanhamento: true,
      editAcompanhamento: false,
      showDadosPessoais: true,
      editDadosPessoais: false,
      showEndereco: true,
      editEndereco: false,
      showPlanosDeSaude: true,
      editPlanosDeSaude: false,
      EstadosBrasil,
      TipoTelefone,
    };
  },
  computed: {
    vRowClass(): string {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 'd-flex flex-column';
      }
      return '';
    },
    paisBrasil(): boolean {
      return this.paciente.estado !== 'EX';
    },
    pacienteEstadoCivil(): string | null {
      if (_.has(estadoCivilStrings, this.paciente.estado_civil)) {
        let estadoCivil: string = estadoCivilStrings[this.paciente.estado_civil];
        if (this.paciente.estado_civil === EstadoCivilPaciente.O
          && !!this.paciente.estado_civil_outro
        ) {
          estadoCivil = `${estadoCivil} (${this.paciente.estado_civil_outro})`;
        }
        return estadoCivil;
      }
      return null;
    },
    planosDeSaudeOrdenados(): PlanoDeSaude[] {
      return _.sortBy(
        this.paciente.planos_de_saude as PlanoDeSaude[],
        el => (!el.preferido),
      );
    },
    acompanhamentoColor() {
      switch (this.paciente.acompanhamento) {
        case Acompanhamento.COLETIVO:
          return 'warning darken-2';
        case Acompanhamento.CASA_DE_PARTO:
          return 'success darken-2';
        case Acompanhamento.PARTICULAR:
          return 'primary darken-2';
        default:
          return 'secondary lighten-2';
      }
    },
    acompanhamentoIcon() {
      switch (this.paciente.acompanhamento) {
        case Acompanhamento.COLETIVO:
          return 'far fa-circle';
        case Acompanhamento.CASA_DE_PARTO:
          return 'fa-clinic-medical';
        case Acompanhamento.PARTICULAR:
          return 'fa-user-md';
        default:
          return 'fa-notes-medical';
      }
    },
    acompanhamentoTexto() {
      switch (this.paciente.acompanhamento) {
        case Acompanhamento.COLETIVO:
          return 'Coletivo Nascer';
        case Acompanhamento.CASA_DE_PARTO:
          return 'Casa de Parto';
        case Acompanhamento.PARTICULAR:
          return `Particular (${this.paciente.responsavel ? this.paciente.responsavel.nome : 'Responsável não selecionada'})`;
        default:
          return 'Em triagem';
      }
    },
    thePacientesCadastroInternoAcompanhamento(): Vue & { preencheForm: () => void } {
      return this.$refs.thePacientesCadastroInternoAcompanhamento as Vue & {
        preencheForm: () => void,
      };
    },
    thePacientesCadastroInternoDadosPessoais(): Vue & { preencheForm: () => void } {
      return this.$refs.thePacientesCadastroInternoDadosPessoais as Vue & {
        preencheForm: () => void,
      };
    },
    thePacientesCadastroInternoEndereco(): Vue & { preencheForm: () => void } {
      return this.$refs.thePacientesCadastroInternoEndereco as Vue & {
        preencheForm: () => void,
      };
    },
    thePacientesCadastroInternoPlanosDeSaude(): Vue & { preencheForm: () => void } {
      return this.$refs.thePacientesCadastroInternoPlanosDeSaude as Vue & {
        preencheForm: () => void,
      };
    },
  },
  methods: {
    atualizaPacienteAcompanhamento(paciente: Paciente) {
      this.$emit('atualizaPaciente', paciente);
      this.editAcompanhamento = false;
    },
    atualizaPacienteDadosPessoais(paciente: Paciente) {
      this.$emit('atualizaPaciente', paciente);
      this.editDadosPessoais = false;
    },
    atualizaPacienteEndereco(paciente: Paciente) {
      this.$emit('atualizaPaciente', paciente);
      this.editEndereco = false;
    },
    atualizaPlanosDeSaude(planosDeSaude: PlanoDeSaude[]) {
      this.$emit('atualizaPlanosDeSaude', planosDeSaude);
      this.editPlanosDeSaude = false;
    },
    // eslint-disable-next-line func-names
    formAcompanhamentoDebounce: _.debounce(function () { this.formAcompanhamento(); }, 200),
    formAcompanhamento() {
      this.showAcompanhamento = true;
      this.editAcompanhamento = true;
      this.$nextTick(() => this.thePacientesCadastroInternoAcompanhamento.preencheForm());
    },
    // eslint-disable-next-line func-names
    formDadosPessoaisDebounce: _.debounce(function () { this.formDadosPessoais(); }, 200),
    formDadosPessoais() {
      this.editDadosPessoais = true;
      this.showDadosPessoais = true;
      this.$nextTick(() => this.thePacientesCadastroInternoDadosPessoais.preencheForm());
    },
    // eslint-disable-next-line func-names
    formEnderecoDebounce: _.debounce(function () { this.formEndereco(); }, 200),
    formEndereco() {
      this.editEndereco = true;
      this.showEndereco = true;
      this.$nextTick(() => this.thePacientesCadastroInternoEndereco.preencheForm());
    },
    // eslint-disable-next-line func-names
    formPlanosDeSaudeDebounce: _.debounce(function () { this.formPlanosDeSaude(); }, 200),
    formPlanosDeSaude() {
      this.editPlanosDeSaude = true;
      this.showPlanosDeSaude = true;
      this.$nextTick(() => this.thePacientesCadastroInternoPlanosDeSaude.preencheForm());
    },
    dataNascimento(dataNascimento: Date): string {
      if (!dataNascimento) {
        return '';
      }
      const momentDataNascimento = moment(dataNascimento);
      const idade = moment().diff(momentDataNascimento, 'years');
      return `${momentDataNascimento.utc().format('DD/MM/YYYY')} (${idade} anos)`;
    },
    iconTelefone(tipoTelefone: string) : string {
      if (_.has(tipoTelefoneIcons, tipoTelefone)) {
        return tipoTelefoneIcons[tipoTelefone];
      }
      return '';
    },
    escolaridade(escolaridade: EscolaridadePaciente): string {
      if (_.has(escolaridadeStrings, escolaridade)) {
        return escolaridadeStrings[escolaridade];
      }
      return '';
    },
    estado(estado: EstadosBrasil): string {
      if (_.has(estadosBrasilStrings, estado)) {
        return estadosBrasilStrings[estado];
      }
      return '';
    },
    simNaoNaoSabe(simNaoNaoSabe: SimNaoNaoSei): string {
      if (_.has(simNaoNaoSabeStrings, simNaoNaoSabe)) {
        return simNaoNaoSabeStrings[simNaoNaoSabe];
      }
      return '';
    },
  },
});
